/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Senddrafts_Empty2Inputs */

const en_coinvestments_senddrafts_empty2 = /** @type {(inputs: Coinvestments_Senddrafts_Empty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There are no pending drafts to send.`)
};

/**
* | output |
* | --- |
* | "There are no pending drafts to send." |
*
* @param {Coinvestments_Senddrafts_Empty2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_senddrafts_empty2 = /** @type {((inputs?: Coinvestments_Senddrafts_Empty2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Senddrafts_Empty2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_senddrafts_empty2(inputs)
});
export { coinvestments_senddrafts_empty2 as "coInvestments_sendDrafts_empty" }